import React from "react"

type PayflexTermProps = {
  term: string
}

export const PayflexTerm = ({ term }: PayflexTermProps) => {
  return (
    <div className="flex max-w-[260px] items-center gap-10 md:items-start">
      <img
        className="h-[22px] w-[22px] md:mt-[2px]"
        src="/icons/payflex-check.svg"
        alt="Checkmark"
      />
      <p className="self-center text-[10px] font-normal text-payflex-navy">
        {term}
      </p>
    </div>
  )
}
